import React, {useEffect, useState} from "react";
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {
    ContentDetailTwoColLayout,
    DetailFormPageShell,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import {skeleton} from "../../../../redux/slice/apiSlice";
import {removeDailyChecks} from "../../../../api/dailyCheck/DailyCheckService";
import {getComputerRoom} from "../../../../api/computerRoom/ComputerRoomService";
import {getApprovalProcessById} from "../../../../api/approval/ApprovalProcessService";
import {CacheType, ContentCategory} from "../../../../constant/CodeSpecNum";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import ApprovalComponent from "../../approval/new/ApprovalComponent";

function ComputerRoomInfo() {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [computerRoom, setComputerRoom] = useState({});
    const refreshCache = useCacheRefresh();

    useEffect(() => {
        if (!id) return;

        setComputerRoom({});

        getComputerRoom(id).then((response) => {
            setComputerRoom(response.data);
            if (response.data.approvalProcessId != null) {
                getApprovalProcessById(response.data.approvalProcessId);
            }
        }).finally(() => dispatch(skeleton(false)));
    }, [id, dispatch]);

    const remove = async () => {
        const response = await removeDailyChecks({ids: [id]});
        if (response.status === 200) {
            alert("일일체크코드가 정상적으로 삭제되었습니다.");
            refreshCache(CacheType.computerRoom);
            navigate("/settings/report/computerRoom");
        }
    };

    if (!computerRoom?.id) {
        return null;
    }

    const basicInfoPanel = (
        <DetailPanel title="기본정보">
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title="소속" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="affiliation"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.affiliation}
                        />
                    </Th_title>
                    <Th_title title="직위" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="position"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.position}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="성명" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="name"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.name}
                        />
                    </Th_title>
                    <Th_title title="연락처" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="phoneNumber"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.phoneNumber}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="방문위치" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="visitLocation"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.visitLocation}
                        />
                    </Th_title>
                    <Th_title title="방문목적" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="visitPurpose"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.visitPurpose}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="입실시간" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="checkInAt"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.checkInAt}
                        />
                    </Th_title>
                    <Th_title title="퇴실시간" colspan={1} className="fieldset-td">
                        <ReadOnlyInputBasic
                            target="checkOutAt"
                            data={{data: computerRoom, setData: setComputerRoom}}
                            value={computerRoom.checkOutAt}
                        />
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col"
            title="전산실 출입관리"
            meta="환경설정 > 방문관리 > 전산실 출입관리 > 상세"
            actions={
                <>
                    {computerRoom.useCount === 0 && (
                        <DetailSummaryButton onClick={() => navigate("/settings/computerRoom/update/" + id)}>
                            수정
                        </DetailSummaryButton>
                    )}
                    {computerRoom.useCount === 0 && (
                        <DetailSummaryButton
                            danger
                            onClick={() => {
                                if (window.confirm("삭제 하시겠습니까?")) remove();
                            }}
                        >
                            삭제
                        </DetailSummaryButton>
                    )}
                    <DetailSummaryListButton url="/settings/computerRoom"/>
                </>
            }
        >
            <DetailListPage className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <div className="asset-detail-list-scroll detail-list-scroll detail-list-scroll--v2-cols">
                        <ContentDetailTwoColLayout
                            main={basicInfoPanel}
                            aside={
                                <ApprovalComponent
                                    contentId={computerRoom.id}
                                    contentCategory={ContentCategory.COMPUTER_ROOM}
                                />
                            }
                        />
                    </div>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {ComputerRoomInfo};
